<template>
    <div class="cont_principal">
    <div class="container">
	<div class="row">
		<div class="container-fluid">
			<h3 class="title">A PROPOS DE MOI</h3>
			<h5 class="description" style="color:white;"> {{ description }} </h5>
		</div>
	</div>
    </div>
    </div>
</template>

<script>export default {
    name: 'APropos',
    props: ['description'],
    }
</script>

<style>
   .cont_principal {
	margin: 0px;
	padding: 0px;
	background-color: #313131;
	color: white;
   }

</style>
